/* istanbul ignore file */

import { FieldIdentifier } from './field-identifier';

export class FormulaPreviewParameters {
    appId: string;
    projectId: string;
    richTextFormula: string;
    usesDateField: boolean;
    fieldsInFormula: FormulaPreviewField[];
}

export class FormulaPreview {
    evaluatedExpression: string;
    previewResult: Date | number;
    siteName: string;
    siteNo: string;
    isPreviewLoading = false;
}

export class FormulaMessages {
    previewMessage: string;
    errorMessage: string;
    dateErrorMessage: string;
    deletedFieldReferencedMessage: string;
}

export class FormulaPreviewField {
    identifier: FieldIdentifier;
    hash: string;
}
